import "./Banner.scss"

export default function Banner(props) {
    return <div className="banner">{props.children}</div>;
}